export const routes = [
  {
    path: '/',
    name: '/explore',
    component: () => import('/home/runner/work/jcc-platform/jcc-platform/frontend/src/pages/explore.vue'),
    /* no children */
  },
  {
    path: '/admin',
    name: '/admin',
    component: () => import('/home/runner/work/jcc-platform/jcc-platform/frontend/src/pages/admin.vue'),
    children: [
      {
        path: '',
        name: '/admin/',
        component: () => import('/home/runner/work/jcc-platform/jcc-platform/frontend/src/pages/admin/index.vue'),
        /* no children */
      },
      {
        path: 'activity',
        name: '/admin/activity',
        component: () => import('/home/runner/work/jcc-platform/jcc-platform/frontend/src/pages/admin/activity.vue'),
        /* no children */
      },
      {
        path: 'admin-tools',
        name: '/admin/admin-tools',
        component: () => import('/home/runner/work/jcc-platform/jcc-platform/frontend/src/pages/admin/admin-tools.vue'),
        /* no children */
      },
      {
        path: 'ai-knowledge',
        name: '/admin/ai-knowledge',
        component: () => import('/home/runner/work/jcc-platform/jcc-platform/frontend/src/pages/admin/ai-knowledge.vue'),
        /* no children */
      },
      {
        path: 'analytics',
        /* internal name: '/admin/analytics' */
        /* no component */
        children: [
          {
            path: '',
            name: '/admin/analytics/',
            component: () => import('/home/runner/work/jcc-platform/jcc-platform/frontend/src/pages/admin/analytics/index.vue'),
            /* no children */
          },
          {
            path: 'credits',
            name: '/admin/analytics/credits',
            component: () => import('/home/runner/work/jcc-platform/jcc-platform/frontend/src/pages/admin/analytics/credits.vue'),
            /* no children */
          },
          {
            path: 'failed-scans',
            name: '/admin/analytics/failed-scans',
            component: () => import('/home/runner/work/jcc-platform/jcc-platform/frontend/src/pages/admin/analytics/failed-scans.vue'),
            /* no children */
          },
          {
            path: 'feedback',
            name: '/admin/analytics/feedback',
            component: () => import('/home/runner/work/jcc-platform/jcc-platform/frontend/src/pages/admin/analytics/feedback.vue'),
            /* no children */
          },
          {
            path: 'quota',
            name: '/admin/analytics/quota',
            component: () => import('/home/runner/work/jcc-platform/jcc-platform/frontend/src/pages/admin/analytics/quota.vue'),
            /* no children */
          },
          {
            path: 'storage',
            name: '/admin/analytics/storage',
            component: () => import('/home/runner/work/jcc-platform/jcc-platform/frontend/src/pages/admin/analytics/storage.vue'),
            /* no children */
          },
          {
            path: 'uploads',
            name: '/admin/analytics/uploads',
            component: () => import('/home/runner/work/jcc-platform/jcc-platform/frontend/src/pages/admin/analytics/uploads.vue'),
            /* no children */
          },
          {
            path: 'users',
            name: '/admin/analytics/users',
            component: () => import('/home/runner/work/jcc-platform/jcc-platform/frontend/src/pages/admin/analytics/users.vue'),
            /* no children */
          },
          {
            path: 'views',
            name: '/admin/analytics/views',
            component: () => import('/home/runner/work/jcc-platform/jcc-platform/frontend/src/pages/admin/analytics/views.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'categories',
        name: '/admin/categories',
        component: () => import('/home/runner/work/jcc-platform/jcc-platform/frontend/src/pages/admin/categories.vue'),
        /* no children */
      },
      {
        path: 'cohort-groups',
        name: '/admin/cohort-groups',
        component: () => import('/home/runner/work/jcc-platform/jcc-platform/frontend/src/pages/admin/cohort-groups.vue'),
        /* no children */
      },
      {
        path: 'dev-tools',
        name: '/admin/dev-tools',
        component: () => import('/home/runner/work/jcc-platform/jcc-platform/frontend/src/pages/admin/dev-tools.vue'),
        /* no children */
      },
      {
        path: 'import',
        name: '/admin/import',
        component: () => import('/home/runner/work/jcc-platform/jcc-platform/frontend/src/pages/admin/import.vue'),
        /* no children */
      },
      {
        path: 'items',
        name: '/admin/items',
        component: () => import('/home/runner/work/jcc-platform/jcc-platform/frontend/src/pages/admin/items.vue'),
        /* no children */
      },
      {
        path: 'pathology-image',
        name: '/admin/pathology-image',
        component: () => import('/home/runner/work/jcc-platform/jcc-platform/frontend/src/pages/admin/pathology-image.vue'),
        /* no children */
      },
      {
        path: 'users',
        /* internal name: '/admin/users' */
        /* no component */
        children: [
          {
            path: '',
            name: '/admin/users/',
            component: () => import('/home/runner/work/jcc-platform/jcc-platform/frontend/src/pages/admin/users/index.vue'),
            /* no children */
          },
          {
            path: ':id',
            name: '/admin/users/[id]',
            component: () => import('/home/runner/work/jcc-platform/jcc-platform/frontend/src/pages/admin/users/[id].vue'),
            /* no children */
          }
        ],
      }
    ],
  },
  {
    path: '/AI-chatbot',
    name: '/AI-chatbot',
    component: () => import('/home/runner/work/jcc-platform/jcc-platform/frontend/src/pages/AI-chatbot.vue'),
    children: [
      {
        path: 'pilot-review',
        name: '/AI-chatbot/pilot-review',
        component: () => import('/home/runner/work/jcc-platform/jcc-platform/frontend/src/pages/AI-chatbot/pilot-review.vue'),
        /* no children */
        meta: {
          "hideFooter": true
        }
      }
    ],
    meta: {
      "hideFooter": true
    }
  },
  {
    path: '/auth',
    /* internal name: '/auth' */
    /* no component */
    children: [
      {
        path: '',
        name: '/auth/',
        component: () => import('/home/runner/work/jcc-platform/jcc-platform/frontend/src/pages/auth/index.vue'),
        /* no children */
      },
      {
        path: 'change-password',
        name: '/auth/change-password',
        component: () => import('/home/runner/work/jcc-platform/jcc-platform/frontend/src/pages/auth/change-password.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/contact',
    name: '/contact',
    component: () => import('/home/runner/work/jcc-platform/jcc-platform/frontend/src/pages/contact.vue'),
    /* no children */
  },
  {
    path: '/dashboard',
    name: '/dashboard',
    component: () => import('/home/runner/work/jcc-platform/jcc-platform/frontend/src/pages/dashboard.vue'),
    /* no children */
  },
  {
    path: '/eula',
    name: '/eula',
    component: () => import('/home/runner/work/jcc-platform/jcc-platform/frontend/src/pages/eula.vue'),
    /* no children */
  },
  {
    path: '/invitation',
    /* internal name: '/invitation' */
    /* no component */
    children: [
      {
        path: ':type',
        /* internal name: '/invitation/[type]' */
        /* no component */
        children: [
          {
            path: ':token',
            name: '/invitation/[type]/[token]',
            component: () => import('/home/runner/work/jcc-platform/jcc-platform/frontend/src/pages/invitation/[type]/[token].vue'),
            /* no children */
            meta: {
              "layout": false
            }
          }
        ],
      }
    ],
  },
  {
    path: '/item',
    /* internal name: '/item' */
    /* no component */
    children: [
      {
        path: ':id',
        /* internal name: '/item/[id]' */
        /* no component */
        children: [
          {
            path: '',
            name: '/item/[id]/',
            component: () => import('/home/runner/work/jcc-platform/jcc-platform/frontend/src/pages/item/[id]/index.vue'),
            /* no children */
          },
          {
            path: 'edit',
            name: '/item/[id]/edit',
            component: () => import('/home/runner/work/jcc-platform/jcc-platform/frontend/src/pages/item/[id]/edit.vue'),
            /* no children */
            meta: {
              "layout": false
            }
          },
          {
            path: 'embed',
            name: '/item/[id]/embed',
            component: () => import('/home/runner/work/jcc-platform/jcc-platform/frontend/src/pages/item/[id]/embed.vue'),
            /* no children */
            meta: {
              "layout": false
            }
          }
        ],
      }
    ],
  },
  {
    path: '/login',
    name: '/login',
    component: () => import('/home/runner/work/jcc-platform/jcc-platform/frontend/src/pages/login.vue'),
    /* no children */
    meta: {
      "layout": false
    }
  },
  {
    path: '/pathology-image',
    /* internal name: '/pathology-image' */
    /* no component */
    children: [
      {
        path: ':id',
        name: '/pathology-image/[id]',
        component: () => import('/home/runner/work/jcc-platform/jcc-platform/frontend/src/pages/pathology-image/[id].vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/privacy-policy',
    name: '/privacy-policy',
    component: () => import('/home/runner/work/jcc-platform/jcc-platform/frontend/src/pages/privacy-policy.vue'),
    /* no children */
  },
  {
    path: '/register',
    name: '/register',
    component: () => import('/home/runner/work/jcc-platform/jcc-platform/frontend/src/pages/register.vue'),
    /* no children */
    meta: {
      "layout": false
    }
  },
  {
    path: '/scenario',
    /* internal name: '/scenario' */
    /* no component */
    children: [
      {
        path: ':id',
        /* internal name: '/scenario/[id]' */
        /* no component */
        children: [
          {
            path: '',
            name: '/scenario/[id]/',
            component: () => import('/home/runner/work/jcc-platform/jcc-platform/frontend/src/pages/scenario/[id]/index.vue'),
            /* no children */
          }
        ],
      }
    ],
  },
  {
    path: '/scene',
    /* internal name: '/scene' */
    /* no component */
    children: [
      {
        path: ':id',
        /* internal name: '/scene/[id]' */
        /* no component */
        children: [
          {
            path: '',
            name: '/scene/[id]/',
            component: () => import('/home/runner/work/jcc-platform/jcc-platform/frontend/src/pages/scene/[id]/index.vue'),
            /* no children */
          },
          {
            path: 'embed',
            name: '/scene/[id]/embed',
            component: () => import('/home/runner/work/jcc-platform/jcc-platform/frontend/src/pages/scene/[id]/embed.vue'),
            /* no children */
            meta: {
              "layout": false
            }
          },
          {
            path: 'stats',
            name: '/scene/[id]/stats',
            component: () => import('/home/runner/work/jcc-platform/jcc-platform/frontend/src/pages/scene/[id]/stats.vue'),
            /* no children */
            meta: {
              "layout": "default"
            }
          }
        ],
      }
    ],
  },
  {
    path: '/settings',
    name: '/settings',
    component: () => import('/home/runner/work/jcc-platform/jcc-platform/frontend/src/pages/settings.vue'),
    /* no children */
  },
  {
    path: '/sorry-to-see-you-go',
    name: '/sorry-to-see-you-go',
    component: () => import('/home/runner/work/jcc-platform/jcc-platform/frontend/src/pages/sorry-to-see-you-go.vue'),
    /* no children */
  },
  {
    path: '/student-directory',
    name: '/student-directory',
    component: () => import('/home/runner/work/jcc-platform/jcc-platform/frontend/src/pages/student-directory.vue'),
    /* no children */
  },
  {
    path: '/test',
    /* internal name: '/test' */
    /* no component */
    children: [
      {
        path: ':id',
        /* internal name: '/test/[id]' */
        /* no component */
        children: [
          {
            path: '',
            name: '/test/[id]/',
            component: () => import('/home/runner/work/jcc-platform/jcc-platform/frontend/src/pages/test/[id]/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'meshy',
        name: '/test/meshy',
        component: () => import('/home/runner/work/jcc-platform/jcc-platform/frontend/src/pages/test/meshy.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/tutorial',
    name: '/tutorial',
    component: () => import('/home/runner/work/jcc-platform/jcc-platform/frontend/src/pages/tutorial.vue'),
    /* no children */
  },
  {
    path: '/u',
    /* internal name: '/u' */
    /* no component */
    children: [
      {
        path: ':id',
        name: '/u/[id]',
        component: () => import('/home/runner/work/jcc-platform/jcc-platform/frontend/src/pages/u/[id].vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/user-groups',
    name: '/user-groups',
    component: () => import('/home/runner/work/jcc-platform/jcc-platform/frontend/src/pages/user-groups.vue'),
    /* no children */
  }
]

export function handleHotUpdate(_router) {
  if (import.meta.hot) {
    import.meta.hot.data.router = _router
  }
}

if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    if (!router) {
      import.meta.hot.invalidate('[unplugin-vue-router:HMR] Cannot replace the routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    for (const route of mod.routes) {
      router.addRoute(route)
    }
    router.replace('')
  })
}

